import { OutgoingDetail, ProformaDetail } from "./Module";

export default {
  Outgoing: OutgoingDetail,
  Proforma: ProformaDetail,
};
